export { default as ThreeDStockContentImageLensResizeButton } from './ThreeDStockContentImageLensResizeButton';
